import { Controller } from '@hotwired/stimulus';
import { track } from '../lib/analytics';

// The floating share pill: copy / LinkedIn / email, with UTM-tagged URLs so
// shared traffic is attributable. Dismissal sticks for the session.
export default class extends Controller {
  static values = { url: String, title: String };
  static targets = ['label', 'banner'];

  connect() {
    if (this.hasBannerTarget && sessionStorage.getItem('flippy-share-dismissed') !== '1') {
      this.bannerTarget.classList.remove('hidden');
      this.bannerTarget.classList.add('flex');
    }
  }

  async copy() {
    // Native share sheet where the platform has one (mobile), clipboard elsewhere.
    if (navigator.share && /Mobi|Android/i.test(navigator.userAgent)) {
      try {
        await navigator.share({ title: this.titleValue, url: this.urlValue });
        track('Tool shared', { method: 'native', url: this.urlValue });
        return;
      } catch (error) {
        if (error.name === 'AbortError') return;
      }
    }

    try {
      await navigator.clipboard.writeText(this.urlValue);
      track('Tool shared', { method: 'clipboard', url: this.urlValue });
      this.flashLabel('Copied!');
    } catch {
      // Clipboard can be blocked (permissions/insecure context): show the
      // URL so the user can copy it by hand instead of failing silently.
      window.prompt('Copy this link:', this.urlValue);
    }
  }

  flashLabel(text) {
    if (!this.hasLabelTarget) return;
    const original = this.labelTarget.textContent;
    this.labelTarget.textContent = text;
    setTimeout(() => { this.labelTarget.textContent = original; }, 2000);
  }

  trackLinkedin() {
    track('Tool shared', { method: 'linkedin', url: this.urlValue });
  }

  trackEmail() {
    track('Tool shared', { method: 'email', url: this.urlValue });
  }

  dismiss() {
    sessionStorage.setItem('flippy-share-dismissed', '1');
    if (this.hasBannerTarget) this.bannerTarget.classList.add('hidden');
  }
}
